module.exports = __webpack_public_path__ + "img/product-preview-13.2847d59.png";